import React from "react";

import { FormHeaderItem } from "stentor-models";

import styles from './SimpleNavigationHeader.module.scss';

interface SimpleNavigationHeaderProps {
    items: FormHeaderItem[];
    onHeaderClick(step: string): void;
    labelHeader?: boolean;
    stepName: string;
    isShowCase?: boolean;
}

export const SimpleNavigationHeader: React.FC<SimpleNavigationHeaderProps> = (
    props: SimpleNavigationHeaderProps
) => {
    const { items, onHeaderClick, labelHeader, stepName, isShowCase } = props;

    if (!!labelHeader) {
        const header = items.find((item) => item.step === stepName);
        const headerText = header?.label;

        // Nothing to say, so nothing is drawn. This used to render the same coloured Box with an
        // empty div inside, which on a step the header has no label for -- the CostGuide booking
        // handoff is not in the header array -- painted a bare teal band above the partner's own
        // form. The band was never authored; it is the header showing up with no content.
        if (headerText === undefined) {
            return null;
        }

        return (
            <div
                className={`${styles.xapp_navigation_header_row} ${
                    !!isShowCase ? styles.xapp_navigation_header_showcase : styles.xapp_navigation_header_container
                }`}>
                <h4 className={styles.xapp_navigation_header_title}>{headerText}</h4>
            </div>
        );
    } else {
        return (
            <div className={`${styles.xapp_navigation_header_row} ${styles.xapp_navigation_header}`}>
                <div className={styles.xapp_navigation_header_track}>
                    {items.map((item, index) => (
                        <div key={index} className={styles.xapp_navigation_header_step}>
                            <button
                                type="button"
                                aria-label={item.label}
                                className={`${styles.xapp_navigation_header} ${styles.xapp_navigation_header_dot}`}
                                onClick={() => {
                                    onHeaderClick(`${item.step}`);
                                }}
                            />
                            <p className={styles.xapp_navigation_header_label}>{item.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
};
